import { render, staticRenderFns } from "./PriceListDetail.vue?vue&type=template&id=5593cb18"
import script from "./PriceListDetail.vue?vue&type=script&lang=js"
export * from "./PriceListDetail.vue?vue&type=script&lang=js"
import style0 from "./PriceListDetail.vue?vue&type=style&index=0&id=5593cb18&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports